export default {
  files: state => bucket => {
    return state.files[bucket];
  }
};


// WEBPACK FOOTER //
// ./src/store/uploader/getters.js